import { useState, useEffect } from "react";
import InlineErrors from "components/shared/InlineErrors";
import InlineDescription from "./InlineDescription";
import "@wdpr/checkbox";

const mainClass = "help-input-checkbox";
const inputCheckboxEvent = "checked-changed";

const renderLabel = (label, required, description) => {
	if (label) {
		if (label.length > 50) {
			return (
				<span
					className={`${mainClass}__label--descriptive`}
					dangerouslySetInnerHTML={{ __html: label }}
				/>
			);
		} else {
			return `${label}${required ? "*" : ""}`;
		}
	} else {
		return "";
	}
};

const InputCheckbox = ({
	id,
	label,
	name,
	required,
	requiredText = "",
	description,
	value,
	handleChange,
	validateInput,
	notEmptyMessage,
	inlineErrors,
	showInlineErrors = true,
	isMobileView,
	useHyperionTheme,
}) => {
	const [hasError, setHasError] = useState();
	const [checkboxValue, setCheckboxValue] = useState({});

	const handleInputCheckboxChange = (event) => {
		if (required && notEmptyMessage && validateInput) {
			validateInput(
				name,
				!value,
				required,
				notEmptyMessage,
				null,
				null,
				setHasError
			);
		}
		if (handleChange) {
			handleChange(event);
		}
	};

	useEffect(() => {
		!!inlineErrors?.[name] && setHasError(true);
	}, [inlineErrors, name]);

	useEffect(() => {
		checkboxValue.target && handleInputCheckboxChange(checkboxValue);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [checkboxValue]);

	useEffect(() => {
		if (useHyperionTheme) {
			const checkboxHandler = (event) => {
				setCheckboxValue({
					target: {
						name,
						checked: event.detail.value,
						value: String(value),
						type: "checkbox",
					},
				});
			};

			document
				.getElementById(id)
				?.addEventListener(inputCheckboxEvent, checkboxHandler);
			return () =>
				window.removeEventListener(inputCheckboxEvent, checkboxHandler);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (!name) return null;

	return (
		<div
			className={`${mainClass} ${
				!description?.text?.title || !required ? `${mainClass}--nonspace` : ""
			} ${!label ? `${mainClass}--unlabeled` : ""}`}
		>
			{description?.text?.title && (
				<h3
					className={`${mainClass}__title`}
					dangerouslySetInnerHTML={{ __html: description.text.title }}
				/>
			)}
			{useHyperionTheme ? (
				<wdpr-checkbox
					id={id}
					checked={!!value ? value : null}
					error={hasError === true ? hasError : null}
					custom-error-aria-label={hasError ? `${id}_error` : ""}
					custom-aria-label={`${label}${
						required && requiredText ? ` ${requiredText}` : ""
					}`}
					alignment="top"
				>
					{renderLabel(label, required, description)}
				</wdpr-checkbox>
			) : (
				<>
					<label
						className={`${mainClass}__label`}
						htmlFor={!hasError ? id : undefined}
						aria-label={
							label &&
							`${label}${required && requiredText ? ` ${requiredText}` : ""} `
						}
					>
						<input
							className={`${mainClass}__input`}
							id={id}
							type="checkbox"
							name={name}
							value={value}
							checked={value}
							aria-describedby={hasError ? `${id}_error` : undefined}
							onChange={(e) => {
								handleInputCheckboxChange(e);
							}}
						/>
						<span
							className={`${mainClass}__check${
								hasError ? ` ${mainClass}__check--error` : ""
							}`}
							tabIndex={0}
							role="checkbox"
							aria-checked={value}
						/>
						{label && `${label}${required ? "*" : ""}`}
					</label>
				</>
			)}
			{description?.modalContent && (
				<InlineDescription
					{...description}
					isMobileView={isMobileView}
					position="top"
				/>
			)}
			{description?.text && (
				<InlineDescription
					{...description}
					isMobileView={isMobileView}
					position="bottom"
					id={id}
				/>
			)}
			{inlineErrors && showInlineErrors && (
				<InlineErrors validate={id} errorMessages={inlineErrors} />
			)}
		</div>
	);
};

export default InputCheckbox;
